<template>
  <div class="sidebar">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="index == 0 ? 'sidebar_first' : ''"
      >
        <router-link
          :to="item.path"
          :class="currentPath == item.path && index > 0 ? 'cur' : ''"
          >{{ item.name }}</router-link
        >
      </li>
    </ul>
  </div>
</template>
    
<script>
import {
  yygkDic,
  yltsDic,
  jxkyDic,
  sjwhDic,
  zyfwDic,
  jkjyDic,
  jyznDic,
  lxwmDic,
  sjkdDic,
} from "../const/slideDic";
import service from "../service/jkjy";
export default {
  props: {},
  data() {
    return {
      list: [],
      currentPath: "",
      yygkDic,
      yltsDic,
      jxkyDic,
      sjwhDic,
      zyfwDic,
      jkjyDic,
      jyznDic,
      lxwmDic,
      sjkdDic,
    };
  },
  methods: {},
  mounted() {
    // 判断用哪个字典项
    let resetPath = JSON.parse(JSON.stringify(this.$route.path));
    let getDic = resetPath.split("/")[1] + "Dic";
    if (getDic == "yygkDic") {
      this.list = this.yygkDic;
    } else if (getDic == "yltsDic") {
      this.list = this.yltsDic;
    } else if (getDic == "jxkyDic") {
      this.list = this.jxkyDic;
    } else if (getDic == "sjwhDic") {
      this.list = this.sjwhDic;
    } else if (getDic == "zyfwDic") {
      this.list = this.zyfwDic;
    } else if (getDic == "jkjyDic") {
      let data = [{ path: "/jkjy", name: "健康教育" }];
      service.getChannelList(
        {
          isshow: "1",
        },
        (res) => {
          res.content.map((m) => {
            this.jkjyDic.map((n) => {
              if (m.name == n.name) {
                data.push(n);
              }
            });
          });
        }
      );

      this.list = data;
    } else if (getDic == "jyznDic") {
      this.list = this.jyznDic;
    } else if (getDic == "lxwmDic") {
      this.list = this.lxwmDic;
    } else if (getDic == "sjkdDic") {
      this.list = this.sjkdDic;
    }

    if (resetPath.indexOf("/article") > -1) {
      let index = resetPath.indexOf("/article");
      this.currentPath = resetPath.substring(0, index);

      // 针对 医疗特色 科室
      if (resetPath.includes("/ylts/kslist")) {
        this.currentPath = "/ylts/home";
      }
      // 针对 医疗特色 医生
      // if (resetPath.includes("/ylts/mingyi")) {
      //   this.currentPath = "/ylts/mingyi";
      // }
    } else {
      if (resetPath == "/sjkd/zbgg/list") {
        this.currentPath = "/sjkd/zbgg";
      } else {
        if (resetPath.includes("/ylts/kslist")) {
          // 针对 医疗特色 科室
          this.currentPath = "/ylts/home";
        } else if (resetPath.includes("/ylts/mingyi/kslist")) {
          // 针对 医疗特色 医生
          this.currentPath = "/ylts/mingyi";
        } else {
          this.currentPath = resetPath;
        }
      }
    }
  },
  watch: {},
  destroyed() {},
};
</script>
<style>
</style>
    
  
     